import { StopOutlined } from '@ant-design/icons';
import { Button, Card, Result } from 'antd';
import React, { useEffect, useState } from 'react';
import LogosEmpresaAseguradora from '../../../../components/LogosEmpresaAseguradora';
import ResponsiveContainer from '../../../../components/ResponsiveContainer';
import StepperSolicitud from '../../../../components/StepperSolicitud';
import { isMobile } from '../../../../utils';
import { instanceRef } from '../../../../utils/axios';
import AmpliacionFinalizacion from './AmpliacionFinalizacion';
import AmpliacionesFotos from './AmpliacionFotos';
import AmpliacionLanding from './AmpliacionLanding';

function AmpliacionSteps(props) {
  const [ampliacion, setAmpliacion] = useState({});
  const [inspeccion, setInspeccion] = useState({});

  useEffect(() => {
    getAmpliacion(props.match.params.token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAmpliacion = async (token) => {
    try {
      const response = await instanceRef.instance.get(`/ampliacion/${token}`);
      getInspeccion(response.data.data.inspeccion.token);
      setAmpliacion(response.data.data);
    } catch (error) {
      // error
    }
  };

  const getInspeccion = async (id) => {
    try {
      const response = await instanceRef.instance.get(`/inspeccion/${id}`);
      setInspeccion(response.data.data);
    } catch (error) {
      // error
    }
    return {};
  };

  return <AmpliaccionSteps ampliacion={ampliacion} inspeccion={inspeccion} />;
}

function AmpliaccionSteps({ ampliacion, inspeccion, data }) {
  const [step, setStep] = useState(0);
  const next = async () => {
    setStep(step + 1);
  };

  const stepPages = [
    <AmpliacionLanding
      ampliacion={ampliacion.ampliacion}
      inspeccion={inspeccion}
    />,
    <AmpliacionesFotos
      ampliacion={ampliacion}
      ampliaciones={ampliacion != null ? ampliacion.ampliacion : []}
      inspeccion={ampliacion != null ? ampliacion.inspeccion : {}}
      finalizar={next}
      next={next}
    />,
    <AmpliacionFinalizacion
      inspeccion={data != null ? data.inspeccion : inspeccion}
    />
  ];

  const steps = [
    {
      title: 'Paso 1',
      description: <span>Datos </span>
    },
    {
      title: 'Paso 2',
      description: <span>Subí las fotos del Vehículo </span>
    },
    {
      title: 'Paso 3',
      description: (
        <span>
          <strong>Finalizar</strong>
        </span>
      )
    }
  ];

  const getButtons = () => {
    if (step === 0) {
      return (
        <Button
          style={{
            marginRight: '16px',
            marginLeft: '16px',
            marginTop: '16px'
          }}
          onClick={next}
        >
          Iniciar
        </Button>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer>
      <LogosEmpresaAseguradora />
      {isMobile ? (
        <Card>
          <>
            {inspeccion.estado === 'FOTOS_SUBIDAS' ? (
              <AmpliacionFinalizacion
                inspeccion={data != null ? data.inspeccion : inspeccion}
              />
            ) : (
              <div>
                <StepperSolicitud current={step} steps={steps.slice(0, 6)} />
                <div>
                  {stepPages[step]}
                  <div>{getButtons()}</div>
                </div>
              </div>
            )}
          </>
        </Card>
      ) : (
        <Card>
          <Result
            icon={<StopOutlined />}
            title="Debe acceder desde un dispositivo móvil"
          />
        </Card>
      )}
    </ResponsiveContainer>
  );
}

export default AmpliacionSteps;
